
export const AI_MODEL = [
    {type: "SUBTABLE", code: "活動履歴", label: "活動履歴"},
    {type: "SINGLE_LINE_TEXT", code: "文字列__1行__メールアドレス", label: "メールアドレス"},
    {type: "STATUS_ASSIGNEE", code: "作業者", label: "作業者"},
    {type: "SINGLE_LINE_TEXT", code: "文字列__1行__部署名", label: "部署名"},
    {type: "UPDATED_TIME", code: "更新日時", label: "更新日時"},
    {type: "SINGLE_LINE_TEXT", code: "文字列__1行__TEL", label: "TEL"},
    {type: "CALC", code: "数値_小計", label: "小計"},
    {type: "CATEGORY", code: "カテゴリー", label: "カテゴリー"},
    {type: "DROP_DOWN", code: "ドロップダウン_製品名", label: "製品名"},
    {type: "SINGLE_LINE_TEXT", code: "文字列__1行__先方担当者", label: "先方担当者"},
    {type: "CREATED_TIME", code: "作成日時", label: "作成日時" }
];

export const PLAN_ID = {
  light_plan: 'plan_GqoZp1qg8tkYF6',
  stand_plan: 'plan_GqoccCS5lM1WNG',
};
